import {adminTypes} from "../actions/_admin_actions";

const studentReducerDefaultState = [];

export default (state = studentReducerDefaultState, action) => {
    switch (action.type) {
        case adminTypes.FETCH_DATA:
            return [
                ...action.vacancies
            ];
        case adminTypes.MANAGE_VACANCY:
            return[
                ...action.newValues
            ]
        case adminTypes.DELETE_VACANCY:
            return[
                ...action.newValues
            ]
        default:
            return state;
    }
}